export const adColumnPreviewStyle = () => ({
  '& .previewAd': {
    width: '100%',
    textAlign: 'left',
    wordWrap: 'break-word', // IE support
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    minWidth: 230,
    fontSize: 13,
    lineHeight: '19px',
  },

  '& .previewTitleAd, & .previewTitleAdNoLink, & .productAd, & .HotelAd': {
    color: '#001BA0',
    fontSize: 20,
  },

  '& .previewUrlAd': {
    color: '#006D21',
    fontSize: 11,
  },

  '& .previewTextAd, & .dynamic-search-ad-preview-text': {
    color: '#666666',
  },

  '& .moreHint': {
    color: '#727272',
  },

  '& .linkToAssets': {
    color: '#0078D4',
  },

  '& .responsive-ad-preview-shared-template': {
    '& div, & p': {
      color: '#767676',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },

    '& img': {
      width: 114,
      height: 60,
      marginRight: 8,
    },

    '& img.verticalVideoThumbnail': {
      width: 34,
      height: 60,
      marginRight: 8,
    },
  },
});
